import React, { useEffect } from 'react';
import svgpanzoom from 'svg-pan-zoom';
import './EleIotGatewayDemo.css';
import classNames from 'classnames';
let schematicDiagram = null;

const const_open = 'open';
const const_close = 'closed';
const const_on = 'on';
const const_off = 'off';


const DeviceSchematicEleIotDemo = sensorData => {

  let { ShowSensors, unitComponentParts, resetDiagram } = sensorData;

  let clsshow_sensor = ShowSensors ? 'show-sensor' : 'hide-sensor';
  const svgElement = document.querySelector('#dv-schematics');
  var options = {
    zoomEnabled: true,
    mouseWheelZoomEnabled: sensorData.enableMouseZoom,
    controlIconsEnabled: true,

    fit: true,
    center: true,
    contain: true
  };

  if (svgElement) {
    schematicDiagram = svgpanzoom(svgElement, options);

    if (sensorData.enableMouseZoom) {
      schematicDiagram.enableMouseWheelZoom();
    } else {
      schematicDiagram.disableMouseWheelZoom();
    }
  }

  const onResize = () => {
    if (schematicDiagram) {
      // schematicDiagram.reset();
      schematicDiagram.resize();
    }
  };

  useEffect(() => {
    window.addEventListener('resize', onResize);
  }, [onResize]); // Only initialize listener on initial render

  useEffect(() => {
    if (resetDiagram && schematicDiagram) {
      schematicDiagram.reset();
    }
  }, [resetDiagram]);

  /*
   ********************************************* SVG TO SVGR CONVERSION***************************************
   
    Following online SVG to SVGR Converter Tool is used 
      https://www.fetoolkit.io/widget/svg-converter  
    Step  1: Save the file as Plain SVG from inkscape
    Step  2: Copy SVG to INPUT section
    Step  3: Disable Clean Up Ids and Remove Unknowns and Defaults from Settings
    Step  4: Select Option JSX
    Step  5: Copy the converted SVG and paste it in notepad++
    Step  6: Remove JSX code, xmlns tag and ...props attribute
    Step  7: Replace {"{# with {
    Step  8: Replace #}"} with }
    Step  9: Replace "{# with {
    Step  10: Replace #}" with }
    Step  11: Replace SVG tag properties as given below
     viewBox="180 110 670 340"
      id="dv-schematics"
      xmlSpace="preserve"
      style={{
        fill: "none",
        fillRule: "evenodd",
        fontSize: 12,
        overflow: "hidden",
        strokeLinecap: "square",
        strokeMiterlimit: 3,

      }}

  */

  const cssHighlightedLineColor = "line-blue-dark";
  const cssHighlightedSensorColor = "sen-blue_dark";

  const getStatePosValue = val => {
    const stateData = sensorData?.SensorData?.state || {};
    return stateData[val] || 'undefined';
  };

  const getStateValue = val => {
    const sensorDisplayData = sensorData?.SensorData || {};
    let returnval = sensorDisplayData[val] === undefined ? 'undefined' : sensorDisplayData[val];
    return returnval;
  };

  const getSensorValue = val => {
    let uom = '';
    let returnval = '';
    const sensorDisplayData = sensorData?.SensorData || {};
    returnval = sensorDisplayData[val] === undefined ? '' : sensorDisplayData[val];
    if (returnval == '')
      return returnval;

    if (unitComponentParts && unitComponentParts.length > 0 && returnval) {
      let sensorInfo = unitComponentParts.find(e => e.Name.toLowerCase() === val.toLowerCase());
      uom = sensorInfo ? (sensorInfo.UoM ? sensorInfo.UoM : '') : '';
      if (uom) returnval = `${returnval} ${uom}`;
    }
    return returnval;
  };

  const getSensorValueAbs = val => {
    let uom = '';
    let returnval = '';
    const sensorDisplayData = sensorData?.SensorData || {};
    returnval = sensorDisplayData[val] === undefined ? '' : sensorDisplayData[val];
    if (returnval == '')
      return returnval;
    return returnval;
  };

  const getStateClass = val => {
    const stateVal = (val != 'undefined' && val.toLowerCase()) || '';
    if (stateVal == const_on || stateVal == const_open) {
      return 'sen-green_dark';
    } else if (stateVal == const_off || stateVal == const_close) {
      return '';
    } else {
      return 'sen-amber';
    }
  };

  const getSensorClass = val => {
    if (val != 'undefined' && (val != '' || val === 0 || val === 0.0)) {
      return 'sen-green_dark';
    } else {
      return 'sen-amber';
    }
  };


  const is_state_value_true = val => {
    val = val && val.toLowerCase();
    if (val == const_open || val == const_on) return true;
    return false;
  };

  const is_sensor_value_true = val => {
    if (val && val != '' && parseFloat(val) > 0) return true;
    return false;
  };

  const getFillValue = (volume, capacity) => {
    let initVal = 10;
    let retVal = initVal
    if (!volume || !capacity) {
      return retVal;
    }
    try {
      retVal = volume / capacity * 100
      if (retVal > 95) {
        retVal = 95
      } else if (retVal < 10) {
        retVal = initVal;
      }
      return retVal
    } catch (ex) {
      return initVal;
    }
  }

  let ptc001_value_abs = getSensorValueAbs('ptc001_pressure');
  let ptc002_value_abs = getSensorValueAbs('ptc002_pressure');
  let ptc003_value_abs = getSensorValueAbs('ptc003_pressure');
  let ftr001_value_abs = getSensorValueAbs('ftr001_flowrate');
  let tnk001_value_abs = getSensorValueAbs('tnk001_volume');
  let tnk002_value_abs = getSensorValueAbs('tnk002_volume');

  let ptc001_value = getSensorValue('ptc001_pressure');
  let ptc002_value = getSensorValue('ptc002_pressure');
  let ptc003_value = getSensorValue('ptc003_pressure');
  let ftr001_value = getSensorValue('ftr001_flowrate');
  let tnk001_value = getSensorValue('tnk001_volume');
  let tnk002_value = getSensorValue('tnk002_volume');

  let vbl001_position = getStateValue('vbl001_position');
  let vbl002_position = getStateValue('vbl002_position');
  let vbl003_position = getStateValue('vbl003_position');
  let vbl004_position = getStateValue('vbl004_position');
  let vbl005_position = getStateValue('vbl005_position');

  let ppf001_position = getStateValue('ppf001_state');
  let vpr001_position = "on";


  // Tank classes
  let clstnk001_body = "";
  let clstnk002_body = "tnk002-body";

  // Input/Output water classes
  let clsinput_water_body = "input-water-body";


  // Valve block classes
  let clsvbl001_body = getStateClass(vbl001_position);
  let clsvbl002_body = getStateClass(vbl002_position);
  let clsvbl003_body = getStateClass(vbl003_position);
  let clsvbl004_body = getStateClass(vbl004_position);
  let clsvbl005_body = getStateClass(vbl005_position);
  let clsppf001_body = getStateClass(ppf001_position);


  let clsfln001_body_outside = "fln001-body-outside";
  let clsdrain_body = "drain-body";

  let clsptc001_body = getSensorClass(ptc001_value);
  let clsptc002_body = getSensorClass(ptc002_value);
  let clsptc003_body = getSensorClass(ptc003_value);

  let clsftr001_body = getSensorClass(ftr001_value);



  let clsvpr001_body = getSensorClass(vpr001_position);;



  let clsvml001_body = "vml001-body";
  let clsvml002_body = "vml002-body";




  let clstnk001_output_line = is_state_value_true(vbl001_position) && is_state_value_true(ppf001_position) ? cssHighlightedLineColor : '';
  let clstnk002_output_line = is_state_value_true(vbl002_position) ? cssHighlightedLineColor : '';

  let clsinput_water_line = "";

  let clsppf001_input_line = is_state_value_true(vbl001_position) ? clstnk001_output_line : '';
  if (clsppf001_input_line == '') {
    clsppf001_input_line = is_state_value_true(vbl002_position) ? clstnk002_output_line : '';
  }

  let clsppf001_output_line = is_state_value_true(ppf001_position) ? clsppf001_input_line : '';
  let clsfln001_body = clsppf001_output_line != '' ? cssHighlightedSensorColor : '';
  let clsfln001_output_line = clsppf001_output_line;
  let clsfln001_conc_line = clsppf001_output_line
  let clsvpr001_output_line = is_state_value_true(vpr001_position) ? clsfln001_conc_line : '';

  let clsptc001_line = "ptc001-line";
  let clsptc002_line = "ptc002-line";
  let clsptc003_line = "ptc003-line";
  let clsftr001_line = "ftr001-line";
  let clsvml001_output_line = "vml001-output-line";
  let clsvml002_output_line = "vml002-output-line";

  let clsvbl003_output_line = is_state_value_true(vbl003_position) ? clsfln001_output_line : '';
  let clsvbl004_output_line = is_state_value_true(vbl004_position) ? clsfln001_conc_line : '';
  let clsvbl005_output_line = is_state_value_true(vbl005_position) ? clsvpr001_output_line : '';

  let clsvm_drain_line = "";
  let clsvbl004_output_line1 = clsvbl004_output_line;

  let clsvbl005_output_line1 = clsvbl004_output_line1 || clsvbl005_output_line;


  let clsoutput_water_body = clsfln001_output_line != '' ? '' : '';

  let cls_water_fill_color = '#007bff';
  let tnk001_capacvity = 3.7;
  let tnk002_capacvity = 3.7;
  let tnk001_fill_val = getFillValue(tnk001_value_abs, tnk001_capacvity);
  let tnk002_fill_val = getFillValue(tnk002_value_abs, tnk002_capacvity);

  let tk01fill_value = `${tnk001_fill_val}%`;
  let tk01fill_grad_value = `${tnk001_fill_val + 5}%`;

  let tk02fill_value = `${tnk002_fill_val}%`
  let tk02fill_grad_value = `${tnk002_fill_val + 5}%`;


  return (


    <svg
      viewBox="180 110 670 340"
      id="dv-schematics"
      xmlSpace="preserve"
      style={{
        fill: "none",
        fillRule: "evenodd",
        fontSize: 12,
        overflow: "hidden",
        strokeLinecap: "square",
        strokeMiterlimit: 3,

      }}
    >
      <style id="style1" type="text/css">
        {
          "path,rect{stroke-width:.8px!important}.st1{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:.5}.st2{fill:#000;font-family:Calibri;font-size:.499992em}.st3{font-size:1em}.st6{stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:.5}.st7{fill:none}.st8{stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:.5}.st8,.st9{fill:#fff}.st10{fill:none;stroke:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:.5}.st11{fill:#000;font-family:Calibri;font-size:.499992em;font-style:italic}"
        }
      </style>
      <defs id="Markers">
        <linearGradient id="tnk001_fill" x1={0} x2={0} y1={1} y2={0}>
          <stop offset="0%" stopColor={cls_water_fill_color} id="stop1" />
          <stop
            offset={tk01fill_value}
            stopColor={cls_water_fill_color}
            id="stop2"
          />
          <stop offset={tk01fill_grad_value} stopColor="#fff" id="stop3" />
          <stop offset="100%" stopColor="#fff" id="stop4" />
        </linearGradient>
        <linearGradient id="tnk002_fill" x1={0} x2={0} y1={1} y2={0}>
          <stop offset="0%" stopColor={cls_water_fill_color} id="stop5" />
          <stop
            offset={tk02fill_value}
            stopColor={cls_water_fill_color}
            id="stop6"
          />
          <stop offset={tk02fill_grad_value} stopColor="#fff" id="stop7" />
          <stop offset="100%" stopColor="#fff" id="stop8" />
        </linearGradient>
        <marker
          id="mrkr2-16"
          orient="auto"
          overflow="visible"
          refX={-6.04}
          style={{
            fill: "#000",
            fillOpacity: 1,
            stroke: "#000",
            strokeOpacity: 1,
            strokeWidth: ".16556291390728!important",
          }}
        >
          <use xlinkHref="#lend2" id="use1" transform="scale(-6.04)" />
        </marker>
        <g id="lend2">
          <path id="path1" d="M1 1 0 0l1-1v2" />
        </g>
      </defs>
      <g
        id="tnk001_body"
        className={clstnk001_body}
        transform="translate(255.12 -488.98)"
      >
        <path
          id="tnk001_path"
          fill="url(#tnk001_fill)"
          d="M0 841.89h58.46l6.5 14.18h12.99v-99.22H0z"
          style={{
            stroke: "#000",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 0.5,
          }}
        />
        <text
          id="text2"
          x={30.59}
          y={754.4}
          style={{
            fill: "#000",
            fontFamily: "Calibri",
            fontSize: ".499992em",
          }}
        >
          {"TNK001"}
        </text>
      </g>
      <g
        id="input_water_body"
        className={clsinput_water_body}
        transform="translate(184.25 -549.21)"
      >
        <g id="shape22-6">
          <rect
            id="rect5"
            width={42.52}
            height={21.26}
            y={820.63}
            style={{
              stroke: "#000",
              strokeLinecap: "round",
              strokeLinejoin: "round",
              strokeWidth: 0.5,
            }}
            rx={10.63}
            ry={10.63}
          />
        </g>
        <g id="shape20-8">
          <text
            id="text5"
            x={13.63}
            y={829.46}
            style={{
              fill: "#000",
              fontFamily: "Calibri",
              fontSize: ".499992em",
            }}
          >
            {"INPUT\n\t\t\t\t"}
            <tspan id="tspan5" x={11.62} y={836.46}>
              {"WATER\n"}
            </tspan>
          </text>
        </g>
      </g>
      <g
        id="input_water_line"
        className={clsinput_water_line}
        transform="matrix(1.1088 0 0 1 226.797 -552.695)"
      >
        <path
          id="path6"
          d="M0 834.8h25.33"
          style={{
            stroke: "#000",
            strokeWidth: ".5!important",
            strokeLinecap: "round",
            strokeLinejoin: "round",
          }}
        />
      </g>
      <path
        id="vml_drain_line"
        d="M369.172 431.819h190.48"
        style={{
          fontSize: 12,
          fill: "none",
          fillRule: "evenodd",
          stroke: "#000",
          strokeLinecap: "square",
          strokeMiterlimit: 3,
        }}
        className={clsvm_drain_line}
      />
      <path
        id="vbl004_output_line1"
        d="M560.18 431.86h41.857"
        style={{
          fontSize: 12,
          overflow: "hidden",
          fill: "none",
          fillRule: "evenodd",
          stroke: "#000",
          strokeLinecap: "square",
          strokeMiterlimit: 3,
        }}
        className={clsvbl004_output_line1}
      />
      <path
        id="vbl005_output_line1"
        d="M602.718 431.837h126.438"
        style={{
          fontSize: 12,
          overflow: "hidden",
          fill: "none",
          fillRule: "evenodd",
          stroke: "#000",
          strokeLinecap: "square",
          strokeMiterlimit: 3,
        }}
        className={clsvbl005_output_line1}
      />
      <g
        id="tnk002_body"
        className={clstnk002_body}
        transform="translate(255.12 -630.71)"
      >
        <path
          id="tnk002_path"
          fill="url(#tnk002_fill)"
          d="M0 841.89h58.46l6.5 14.18h12.99v-99.22H0z"
          style={{
            stroke: "#000",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 0.5,
          }}
        />
        <text
          id="text7"
          x={30.73}
          y={753.26}
          style={{
            fill: "#000",
            fontFamily: "Calibri",
            fontSize: ".499992em",
          }}
        >
          {"TNK002"}
        </text>
      </g>
      <g id="shape1067-24" transform="rotate(-90 -85.673 361.59)">
        <path
          id="path10"
          d="M0 841.89h8.65v-8.65H0z"
          style={{
            fill: "none",
          }}
        />
        <path
          id="path11"
          d="M0 841.89h8.65v-8.65H0v8.65"
          style={{
            stroke: "#000",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 0.5,
          }}
        />
        <path
          id="path12"
          d="M4.32 841.89v5.94"
          style={{
            stroke: "#000",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 0.5,
          }}
        />
      </g>
      <path
        id="vbl002_body"
        className={clsvbl002_body}
        d="M405.98 282.4h-10.81l10.81-21.61h-10.81z"
        style={{
          fill: "none",
          stroke: "#000",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: 0.5,
        }}
      />
      <text
        id="vbl002_text"
        x={405.579}
        y={273.739}
        style={{
          fill: "#000",
          fontFamily: "Calibri",
          fontSize: ".499992em",
        }}
      >
        {"VBL002"}
      </text>
      <g id="shape1069-32" transform="rotate(-90 -53.96 393.3)">
        <path
          id="path14"
          d="M0 841.89h8.65v-8.65H0z"
          style={{
            fill: "none",
          }}
        />
        <path
          id="path15"
          d="M0 841.89h8.65v-8.65H0v8.65"
          style={{
            stroke: "#000",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 0.5,
          }}
        />
        <path
          id="path16"
          d="M4.32 841.89v5.94"
          style={{
            stroke: "#000",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 0.5,
          }}
        />
      </g>
      <path
        id="vbl001_body"
        className={clsvbl001_body}
        d="M405.98 345.83h-10.81l10.81-21.61h-10.81z"
        style={{
          fill: "none",
          stroke: "#000",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: 0.5,
        }}
      />
      <text
        id="vbl001_text"
        x={406.962}
        y={336.3}
        style={{
          fill: "#000",
          fontFamily: "Calibri",
          fontSize: ".499992em",
        }}
      >
        {"VBL001"}
      </text>
      <path
        id="path20"
        d="M457.27 292.15a10.807 10.807 0 1 1 0 21.61 10.807 10.807 0 0 1 0-21.61z"
        style={{
          fill: "none",
        }}
      />
      <path
        id="ppf001_body"
        className={clsppf001_body}
        d="M457.27 292.15a10.807 10.807 0 1 1 0 21.61 10.807 10.807 0 0 1 0-21.61"
        style={{
          stroke: "#000",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: 0.5,
        }}
      />
      <path
        id="path22"
        d="m457.27 292.15 10.8 10.81-10.8 10.8"
        style={{
          stroke: "#000",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: 0.5,
        }}
      />
      <path
        id="path23"
        d="M446.46 302.96h21.61"
        style={{
          stroke: "#000",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: 0.5,
        }}
      />
      <text
        id="ppf001_text"
        x={448.76}
        y={319.816}
        style={{
          fill: "#000",
          fontFamily: "Calibri",
          fontSize: ".499992em",
        }}
      >
        {"PPF001"}
      </text>
      <path
        id="ppf001_input_line"
        className={clsppf001_input_line}
        d="M400.59 324.2v-21.244h45.802m-45.802-20.535v20.534h45.802"
        style={{
          stroke: "#000",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: 0.5359,
        }}
      />
      <g
        id="fln001_body_outside"
        className={clsfln001_body_outside}
        transform="translate(637.44 -552.76)"
      >
        <path
          id="path28"
          d="M0 836.57a10.804 6.474-180 0 0 21.26 0V734.53a10.804 6.474-180 0 0-21.26 0z"
          style={{
            fill: "#fff",
            stroke: "#000",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 0.5,
          }}
        />
      </g>
      <path
        id="path29"
        d="M637.44 282.05v-99.21h21.26v99.21z"
        style={{
          fill: "#fff",
        }}
      />
      <path
        id="fln001_body"
        className={clsfln001_body}
        d="M637.44 282.05v-99.21h21.26v99.21h-21.26"
        style={{
          stroke: "#000",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: 0.5,
        }}
      />
      <path
        id="path31"
        d="m637.44 282.05 3.04-14.19"
        style={{
          stroke: "#000",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: 0.5,
        }}
      />
      <path
        id="path32"
        d="m642.67 257.64 3.89-18.15"
        style={{
          stroke: "#000",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: 0.5,
        }}
      />
      <path
        id="path33"
        d="m649.58 225.4 3.04-14.19"
        style={{
          stroke: "#000",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: 0.5,
        }}
      />
      <path
        id="path34"
        d="m655.66 197.02 3.04-14.18"
        style={{
          stroke: "#000",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: 0.5,
        }}
      />
      <text
        id="text34"
        x={617.251}
        y={228.997}
        style={{
          fill: "#000",
          fontFamily: "Calibri",
          fontSize: ".499992em",
        }}
      >
        {"FLN001"}
      </text>
      <g id="shape1147-67" transform="translate(646.3 -540.56)">
        <path
          id="rect34"
          d="M0 833.09h25.512v8.802H0z"
          style={{
            fill: "none",
            stroke: "none",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 0.5,
          }}
        />
        <text
          id="text35"
          x={9.94}
          y={839.29}
          style={{
            fill: "#000",
            fontFamily: "Calibri",
            fontSize: ".499992em",
            fontStyle: "italic",
          }}
        >
          {"Feed"}
        </text>
      </g>
      <g id="shape1148-70" transform="translate(612.23 -664.43)">
        <path
          id="rect35"
          d="M0 833.09h42.52v8.802H0z"
          style={{
            fill: "none",
            stroke: "none",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 0.5,
          }}
        />
        <text
          id="text36"
          x={4}
          y={839.29}
          style={{
            fill: "#000",
            fontFamily: "Calibri",
            fontSize: ".499992em",
            fontStyle: "italic",
          }}
        >
          {"Concentrate"}
        </text>
      </g>
      <g id="shape1150-74" transform="rotate(-90 58.363 346.35)">
        <path
          id="path37"
          d="M0 841.89h8.65v-8.65H0z"
          style={{
            fill: "none",
          }}
        />
        <path
          id="path38"
          d="M0 841.89h8.65v-8.65H0v8.65"
          style={{
            stroke: "#000",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 0.5,
          }}
        />
        <path
          id="path39"
          d="M4.32 841.89v5.94"
          style={{
            stroke: "#000",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 0.5,
          }}
        />
      </g>
      <path
        id="vbl004_body"
        className={clsvbl004_body}
        d="M565.25 411.2h-10.81l10.81-21.61h-10.81z"
        style={{
          fill: "none",
          stroke: "#000",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: 0.5,
        }}
      />
      <text
        id="vbl004_text"
        x={522.71}
        y={402.161}
        style={{
          fill: "#000",
          fontFamily: "Calibri",
          fontSize: ".499992em",
        }}
      >
        {"VBL004"}
      </text>
      <g id="shape1163-84" transform="translate(657.64 -650.4)">
        <path
          id="rect41"
          d="M0 833.09h42.52v8.802H0z"
          style={{
            fill: "none",
            stroke: "none",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 0.5,
          }}
        />
        <text
          id="text41"
          x={4}
          y={839.29}
          style={{
            fill: "#000",
            fontFamily: "Calibri",
            fontSize: ".499992em",
            fontStyle: "italic",
          }}
        >
          {"Filtrate"}
        </text>
      </g>
      <g id="shape1165-88" transform="rotate(90 694.4 855.01)">
        <path
          id="path43"
          d="M0 841.89h8.65v-8.65H0z"
          style={{
            fill: "none",
          }}
        />
        <path
          id="path44"
          d="M0 841.89h8.65v-8.65H0v8.65"
          style={{
            stroke: "#000",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 0.5,
          }}
        />
        <path
          id="path45"
          d="M4.32 841.89v5.94"
          style={{
            stroke: "#000",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 0.5,
          }}
        />
      </g>
      <path
        id="vbl003_body"
        className={clsvbl003_body}
        d="M696.17 154.13h10.81l-10.81 21.61h10.81z"
        style={{
          fill: "none",
          stroke: "#000",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: 0.5,
        }}
      />
      <text
        id="vbl003_text"
        x={717.93}
        y={167.274}
        style={{
          fill: "#000",
          fontFamily: "Calibri",
          fontSize: ".499992em",
        }}
      >
        {"VBL003"}
      </text>
      <g
        id="drain_body"
        className={clsdrain_body}
        transform="translate(729.92 -398.27)"
      >
        <g id="shape1229-100">
          <rect
            id="rect49"
            width={42.52}
            height={25.512}
            y={816.38}
            style={{
              stroke: "#000",
              strokeLinecap: "round",
              strokeLinejoin: "round",
              strokeWidth: 0.5,
            }}
            rx={12.756}
            ry={12.756}
          />
        </g>
        <g id="shape1227-102">
          <text
            id="text49"
            x={13.36}
            y={827.33}
            style={{
              fill: "#000",
              fontFamily: "Calibri",
              fontSize: ".499992em",
            }}
          >
            {"DRAIN \n\t\t\t\t"}
            <tspan id="tspan49" x={12.3} y={835.33}>
              {"WATER"}
            </tspan>
          </text>
        </g>
      </g>
      <g
        id="ptc002_body"
        className={clsptc002_body}
        transform="translate(339.8 -651.97)"
      >
        <g id="group1405-111" transform="translate(.354)">
          <g id="shape1406-112">
            <path
              id="path53"
              d="M10.63 841.89a10.63 10.63-180 0 0 0-21.26 10.63 10.63-180 1 0 0 21.26z"
              style={{
                fill: "#fff",
              }}
            />
            <path
              id="path54"
              d="M10.63 841.89a10.63 10.63-180 0 0 0-21.26 10.63 10.63-180 1 0 0 21.26"
              style={{
                stroke: "#000",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: 0.5,
              }}
            />
            <path
              id="path55"
              d="M0 831.26h21.26"
              style={{
                stroke: "#000",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: 0.5,
              }}
            />
            <path
              id="path56"
              d="M0 831.26h21.26"
              style={{
                stroke: "#000",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: 0.5,
              }}
            />
          </g>
          <g id="shape1405-118">
            <text
              id="text56"
              x={6.07}
              y={838.38}
              style={{
                fill: "#000",
                fontFamily: "Calibri",
                fontSize: ".499992em",
              }}
            >
              {"002"}
            </text>
          </g>
        </g>
        <g id="shape1408-120" transform="translate(0 -10.63)">
          <path
            id="rect57"
            d="M0 834.09h21.26v7.795H0z"
            style={{
              fill: "none",
              stroke: "none",
              strokeLinecap: "round",
              strokeLinejoin: "round",
              strokeWidth: 0.5,
            }}
          />
          <text
            id="text57"
            x={6.02}
            y={839.79}
            style={{
              fill: "#000",
              fontFamily: "Calibri",
              fontSize: ".499992em",
            }}
          >
            {"PTC"}
          </text>
        </g>
      </g>
      <g
        id="ptc002_line"
        className={clsptc002_line}
        transform="translate(350.79 -651.97)"
      >
        <path
          id="path58"
          d="M0 841.89v14.17h-17.72"
          style={{
            stroke: "#000",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 0.5,
          }}
        />
      </g>
      <g
        id="ptc001_body"
        className={clsptc001_body}
        transform="translate(340.16 -510.24)"
      >
        <g id="group1411-127" transform="translate(.354)">
          <g id="shape1412-128">
            <path
              id="path61"
              d="M10.63 841.89a10.63 10.63-180 0 0 0-21.26 10.63 10.63-180 1 0 0 21.26z"
              style={{
                fill: "#fff",
              }}
            />
            <path
              id="path62"
              d="M10.63 841.89a10.63 10.63-180 0 0 0-21.26 10.63 10.63-180 1 0 0 21.26"
              style={{
                stroke: "#000",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: 0.5,
              }}
            />
            <path
              id="path63"
              d="M0 831.26h21.26"
              style={{
                stroke: "#000",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: 0.5,
              }}
            />
            <path
              id="path64"
              d="M0 831.26h21.26"
              style={{
                stroke: "#000",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: 0.5,
              }}
            />
          </g>
          <g id="shape1411-134">
            <text
              id="text64"
              x={6.07}
              y={838.38}
              style={{
                fill: "#000",
                fontFamily: "Calibri",
                fontSize: ".499992em",
              }}
            >
              {"001"}
            </text>
          </g>
        </g>
        <g id="shape1414-136" transform="translate(0 -10.63)">
          <path
            id="rect65"
            d="M0 834.09h21.26v7.795H0z"
            style={{
              fill: "none",
              stroke: "none",
              strokeLinecap: "round",
              strokeLinejoin: "round",
              strokeWidth: 0.5,
            }}
          />
          <text
            id="text65"
            x={6.02}
            y={839.79}
            style={{
              fill: "#000",
              fontFamily: "Calibri",
              fontSize: ".499992em",
            }}
          >
            {"PTC"}
          </text>
        </g>
      </g>
      <g
        id="ptc001_line"
        className={clsptc001_line}
        transform="translate(351.14 -510.24)"
      >
        <path
          id="path66"
          d="M0 841.89v14.17h-18.07"
          style={{
            stroke: "#000",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 0.5,
          }}
        />
      </g>
      <g
        id="ptc003_body"
        className={clsptc003_body}
        transform="translate(485.26 -556.65)"
      >
        <g id="group1417-143" transform="translate(.177)">
          <g id="shape1418-144">
            <path
              id="path69"
              d="M10.63 841.89a10.63 10.63-180 0 0 0-21.26 10.63 10.63-180 1 0 0 21.26z"
              style={{
                fill: "#fff",
              }}
            />
            <path
              id="path70"
              d="M10.63 841.89a10.63 10.63-180 0 0 0-21.26 10.63 10.63-180 1 0 0 21.26"
              style={{
                stroke: "#000",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: 0.5,
              }}
            />
            <path
              id="path71"
              d="M0 831.26h21.26"
              style={{
                stroke: "#000",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: 0.5,
              }}
            />
            <path
              id="path72"
              d="M0 831.26h21.26"
              style={{
                stroke: "#000",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: 0.5,
              }}
            />
          </g>
          <g id="shape1417-150">
            <text
              id="text72"
              x={6.07}
              y={838.38}
              style={{
                fill: "#000",
                fontFamily: "Calibri",
                fontSize: ".499992em",
              }}
            >
              {"003"}
            </text>
          </g>
        </g>
        <g id="shape1420-152" transform="translate(0 -10.63)">
          <path
            id="rect73"
            d="M0 834.09h21.26v7.795H0z"
            style={{
              fill: "none",
              stroke: "none",
              strokeLinecap: "round",
              strokeLinejoin: "round",
              strokeWidth: 0.5,
            }}
          />
          <text
            id="text73"
            x={6.02}
            y={839.79}
            style={{
              fill: "#000",
              fontFamily: "Calibri",
              fontSize: ".499992em",
            }}
          >
            {"PTC"}
          </text>
        </g>
      </g>
      <g
        id="ptc003_line"
        className={clsptc003_line}
        transform="matrix(1 0 0 1.0121 489.15 -566.38)"
      >
        <path
          id="path74"
          d="M7.09 841.89v17.01"
          style={{
            stroke: "#000",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 0.5,
          }}
        />
      </g>
      <g
        id="ftr001_body"
        className={clsftr001_body}
        transform="translate(520.69 -555.94)"
      >
        <g id="group1423-159" transform="translate(.354)">
          <g id="shape1424-160">
            <path
              id="path77"
              d="M10.63 841.89a10.63 10.63-180 0 0 0-21.26 10.63 10.63-180 1 0 0 21.26z"
              style={{
                fill: "#fff",
              }}
            />
            <path
              id="path78"
              d="M10.63 841.89a10.63 10.63-180 0 0 0-21.26 10.63 10.63-180 1 0 0 21.26"
              style={{
                stroke: "#000",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: 0.5,
              }}
            />
            <path
              id="path79"
              d="M0 831.26h21.26"
              style={{
                stroke: "#000",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: 0.5,
              }}
            />
            <path
              id="path80"
              d="M0 831.26h21.26"
              style={{
                stroke: "#000",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: 0.5,
              }}
            />
          </g>
          <g id="shape1423-166">
            <text
              id="text80"
              x={6.07}
              y={838.38}
              style={{
                fill: "#000",
                fontFamily: "Calibri",
                fontSize: ".499992em",
              }}
            >
              {"001"}
            </text>
          </g>
        </g>
        <g id="shape1426-168" transform="translate(0 -10.63)">
          <path
            id="rect81"
            d="M0 834.09h21.26v7.795H0z"
            style={{
              fill: "none",
              stroke: "none",
              strokeLinecap: "round",
              strokeLinejoin: "round",
              strokeWidth: 0.5,
            }}
          />
          <text
            id="text81"
            x={6.16}
            y={839.79}
            style={{
              fill: "#000",
              fontFamily: "Calibri",
              fontSize: ".499992em",
            }}
          >
            {"FTR"}
          </text>
        </g>
      </g>
      <g
        id="ftr001_line"
        className={clsftr001_line}
        transform="translate(524.59 -555.94)"
      >
        <path
          id="path82"
          d="M7.09 841.89v17.01"
          style={{
            stroke: "#000",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 0.5,
          }}
        />
      </g>
      <g id="shape1519-175" transform="rotate(-90 78.878 324.6)">
        <path
          id="path84"
          d="M0 841.89h8.65v-8.65H0z"
          style={{
            fill: "none",
          }}
        />
        <path
          id="path85"
          d="M0 841.89h8.65v-8.65H0v8.65"
          style={{
            stroke: "#000",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 0.5,
          }}
        />
        <path
          id="path86"
          d="M4.32 841.89v5.94"
          style={{
            stroke: "#000",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 0.5,
          }}
        />
      </g>
      <path
        id="vbl005_body"
        className={clsvbl005_body}
        d="M607.52 409.96h-10.81l10.81-21.61h-10.81z"
        style={{
          fill: "none",
          stroke: "#000",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: 0.5,
        }}
      />
      <text
        id="vbl005_text"
        x={608.987}
        y={401.602}
        style={{
          fill: "#000",
          fontFamily: "Calibri",
          fontSize: ".499992em",
        }}
      >
        {"VBL005"}
      </text>
      <path
        id="fln001_conc_line"
        className={clsfln001_conc_line}
        d="M648.07 176.46v-20.55h-45.96v189.92m45.96-169.37v-20.55h-88.23v233.68"
        style={{
          stroke: "#000",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: 0.5,
        }}
      />
      <g id="shape1523-186" transform="rotate(-90 66.534 300.91)">
        <path
          id="path89"
          d="m10.81 836.49 1.08-5.41H9.73z"
          style={{
            fill: "#000",
            stroke: "#000",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 0.5,
          }}
        />
      </g>
      <path
        id="vpr001_body"
        className={clsvpr001_body}
        d="M607.52 367.44h-10.81l10.81-21.61h-10.81z"
        style={{
          fill: "#fff",
          stroke: "#000",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: 0.5,
        }}
      />
      <text
        id="vpr001_text"
        x={609.781}
        y={358.431}
        style={{
          fill: "#000",
          fontFamily: "Calibri",
          fontSize: ".499992em",
        }}
      >
        {"VPR001"}
      </text>
      <g transform="translate(595.03 -474.45)" id="g1">
        <path
          id="vpr001_output_line"
          className={clsvpr001_output_line}
          d="M7.09 841.89v20.91"
          style={{
            stroke: "#000",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 0.5,
          }}
        />
      </g>
      <path
        id="vml002_output_line"
        className={clsvml002_output_line}
        d="M368.757 410.405v20.91"
        style={{
          fontSize: 12,
          fill: "none",
          fillRule: "evenodd",
          stroke: "#000",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeMiterlimit: 3,
        }}
      />
      <path
        id="vbl004_output_line"
        className={clsvbl004_output_line}
        d="M560.142 411.391v20.507"
        style={{
          fontSize: 12,
          overflow: "hidden",
          fill: "none",
          fillRule: "evenodd",
          stroke: "#000",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeMiterlimit: 3,
        }}
      />
      <path
        id="vbl005_output_line"
        className={clsvbl005_output_line}
        d="M602.207 410.56v20.506"
        style={{
          fontSize: 12,
          overflow: "hidden",
          fill: "none",
          fillRule: "evenodd",
          stroke: "#000",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeMiterlimit: 3,
        }}
      />
      <g transform="translate(333.07 -701.75)" id="g2">
        <path
          id="vbl003_output_line"
          className={clsvbl003_output_line}
          d="M0 842.07h368.5v13.81"
          style={{
            stroke: "#000",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 0.5,
          }}
        />
      </g>
      <path
        id="path94"
        d="M331.3 388.35h-10.63l10.63 21.26h-10.63z"
        style={{
          fill: "#fff",
        }}
      />
      <path
        id="vml001_body"
        className={clsvml001_body}
        d="M331.3 388.35h-10.63l10.63 21.26h-10.63l10.63-21.26"
        style={{
          stroke: "#000",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: 0.5,
        }}
      />
      <path
        id="path96"
        d="M325.98 398.98h10.63"
        style={{
          stroke: "#000",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: 0.5,
        }}
      />
      <path
        id="path97"
        d="M336.61 393.66v10.63"
        style={{
          stroke: "#000",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: 0.5,
        }}
      />
      <text
        id="text97"
        x={299}
        y={400.776}
        style={{
          fill: "#000",
          fontFamily: "Calibri",
          fontSize: ".499992em",
        }}
      >
        {"VML001"}
      </text>
      <path
        id="path98"
        d="M373.82 388.35h-10.63l10.63 21.26h-10.63z"
        style={{
          fill: "#fff",
        }}
      />
      <path
        id="vml002_body"
        className={clsvml002_body}
        d="M373.82 388.35h-10.63l10.63 21.26h-10.63l10.63-21.26"
        style={{
          stroke: "#000",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: 0.5,
        }}
      />
      <path
        id="path100"
        d="M368.5 398.98h10.63"
        style={{
          stroke: "#000",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: 0.5,
        }}
      />
      <path
        id="path101"
        d="M379.13 393.66v10.63"
        style={{
          stroke: "#000",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: 0.5,
        }}
      />
      <text
        id="text101"
        x={384.227}
        y={400.946}
        style={{
          fill: "#000",
          fontFamily: "Calibri",
          fontSize: ".499992em",
        }}
      >
        {"VML002"}
      </text>
      <path
        id="tnk002_output_line"
        className={clstnk002_output_line}
        d="M325.98 225.36v7.08h42.52v155.91m-42.52-162.99v7.08h74.59v28.35"
        style={{
          stroke: "#000",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: 0.5,
        }}
      />
      <g
        id="output_water_body"
        className={clsoutput_water_body}
        transform="translate(729.92 -641.34)"
      >
        <g id="shape1560-222">
          <rect
            id="rect105"
            width={42.52}
            height={21.26}
            y={820.63}
            style={{
              stroke: "#000",
              strokeLinecap: "round",
              strokeLinejoin: "round",
              strokeWidth: 0.5,
            }}
            rx={10.63}
            ry={10.63}
          />
        </g>
        <g id="shape1558-224">
          <text
            id="text105"
            x={10.95}
            y={829.46}
            style={{
              fill: "#000",
              fontFamily: "Calibri",
              fontSize: ".499992em",
            }}
          >
            {"OUTPUT\n\t\t\t\t"}
            <tspan id="tspan105" x={11.62} y={836.46}>
              {" WATER"}
            </tspan>
          </text>
        </g>
      </g>
      <path
        id="tnk001_output_line"
        className={clstnk001_output_line}
        d="M363.49 374.08a5.209 7.115 0 0 1 5.222-6.92 5.209 7.115 0 0 1 5.193 6.96m.014.065h26.669v-28.362m-74.609 21.264v7.094h37.45m-37.513-7.087v21.26"
        style={{
          strokeWidth: 0.504,
          stroke: "#000304",
        }}
      />
      <path
        id="ppf001_output_line"
        className={clsppf001_output_line}
        d="M596.42 302.82a5.358 7.111 0 0 1 5.371-6.916 5.358 7.111 0 0 1 5.341 6.957m-53.04-.077a5.358 7.111 0 0 1 5.371-6.917 5.358 7.111 0 0 1 5.341 6.957m42.354.13h40.923v-13.832m-83.187 13.738h31.222m-127.63.085h85.635"
        style={{
          strokeWidth: 0.51102,
          stroke: "#000304",
        }}
      />
      <path
        id="vml001_output_line"
        className={clsvml001_output_line}
        d="M325.801 409.691v22.135h42.867"
        style={{
          stroke: "#000",
          strokeLinecap: "round",
          strokeLinejoin: "round",
        }}
      />
      <path
        id="fln001_output_line"
        className={clsfln001_output_line}
        d="m701.61 176.08.23 14.585m-42.924.322 70.718.17"
        style={{
          fill: "#000",
          strokeWidth: 0.50123,
          stroke: "#000405",
        }}
      />
      <text
        id="ptc003_text"
        x={494.172}
        y={259.62}
        className={clsshow_sensor}
        style={{
          fontSize: "5.9999px",
          fontFamily: "Calibri",
          fill: "#000",
        }}
        textAnchor="middle"
      >
        {ptc003_value}
      </text>
      <text
        id="ftr001_text"
        x={533.274}
        y={259.111}
        className={clsshow_sensor}
        style={{
          fontSize: "5.9999px",
          fontFamily: "Calibri",
          overflow: "hidden",
          fill: "#000",
          fillRule: "evenodd",
          strokeWidth: 10,
          strokeLinecap: "square",
          strokeMiterlimit: 3,
        }}
        textAnchor="middle"
      >
        {ftr001_value}
      </text>
      <text
        id="tnk001_text"
        x={297.284}
        y={257.822}
        className={clsshow_sensor}
        style={{
          fontSize: "5.9999px",
          fontFamily: "Calibri",
          overflow: "hidden",
          fill: "#000",
          fillRule: "evenodd",
          strokeWidth: 10,
          strokeLinecap: "square",
          strokeMiterlimit: 3,
        }}
        textAnchor="middle"
      >
        {tnk001_value}
      </text>
      <text
        id="ptc001_text"
        x={351.744}
        y={304.871}
        className={clsshow_sensor}
        style={{
          fontSize: "5.9999px",
          fontFamily: "Calibri",
          overflow: "hidden",
          fill: "#000",
          fillRule: "evenodd",
          strokeWidth: 10,
          strokeLinecap: "square",
          strokeMiterlimit: 3,
        }}
        textAnchor="middle"
      >
        {ptc001_value}
      </text>
      <text
        id="tnk002_text"
        x={296.93}
        y={115.943}
        className={clsshow_sensor}
        style={{
          fontSize: "5.9999px",
          fontFamily: "Calibri",
          overflow: "hidden",
          fill: "#000",
          fillRule: "evenodd",
          strokeWidth: 10,
          strokeLinecap: "square",
          strokeMiterlimit: 3,
        }}
        textAnchor="middle"
      >
        {tnk002_value}
      </text>
      <text
        id="ptc002_text"
        x={348.322}
        y={164.985}
        className={clsshow_sensor}
        style={{
          fontSize: "5.9999px",
          fontFamily: "Calibri",
          fill: "#000",
        }}
        textAnchor="middle"
      >
        {ptc002_value}
      </text>
    </svg>


  );
};

export default DeviceSchematicEleIotDemo;
